import React, { useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import { Button, TextField, Table, TableHead, TableBody, TableRow, TableCell, CircularProgress } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import dayjs from 'dayjs';
import dateFormat from 'dateformat';
import {bffUrl} from '../config.js';
import { urlConfig } from "../config";
import './DatePickerStyles.css';


const IngestionStatsHelper = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [data, setData] = useState([]);
    const [FinalstartDate, setfinalStartDate] = useState('');
    const [FinalendDate, setfinalEndDate] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    console.log(startDate, endDate)
  
    const handleStartDateChange = (event) => {
      setStartDate(event.target.value);
      const startDate = new Date(event.target.value);
      startDate.setHours(0, 0, 1); // Set hours, minutes, and seconds to 00:00:01
      console.log(startDate)
      const formattedStartDate = dateFormat(startDate, "yyyy-mm-dd HH:MM:ss");
      console.log(formattedStartDate);
      setfinalStartDate(formattedStartDate)
    };
  
    const handleEndDateChange = (event) => {
      setEndDate(event.target.value);
      const endDate = new Date(event.target.value)
      endDate.setHours(23, 59, 59) // Set hours, minutes, and seconds to 23:59:59
      const formattedEndDate = dateFormat(endDate, "yyyy-mm-dd HH:MM:ss");
      console.log(formattedEndDate);
      setfinalEndDate(formattedEndDate)
    };
  
    const fetchData = () => {
      if (!startDate || !endDate) {
          alert('Please select a date range first.');
          return;
        }
      
      setIsLoading(true);
      axios
        .get(`${urlConfig.bffUrl}/ingestion/getDailyIngestionData?startDate=${FinalstartDate}&endDate=${FinalendDate}`)
      //   .get(`http://localhost:1339/ingestion/getDailyIngestionData?startDate=${FinalstartDate}&endDate=${FinalendDate}`)
        .then((response) => {console.log(response)
          setData(response.data);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
  
    const csvHeaders = [
      { label: 'CID', key: 'cid' },
      { label: 'Short Title', key: 'shorttitle' },
      { label: 'CP Name', key: 'cpname' },
      { label: 'GenreName', key: 'genrename' },
      { label: 'Subgenre', key: 'subgenre' },
      { label: 'SubSubgenre', key: 'subsubgenre' },
      { label: 'Duration', key: 'duration' },
      { label: 'Resolution', key: 'Resolution' },
      { label: 'V Bitrate', key: 'v_bitrate' },
      { label: 'UploadTime', key: 'uploadtime' },
      // Add more header objects based on your JSON response
    ];
  
    // Number of rows to display per page
    const rowsPerPage = 20;
  
    // Calculate the total number of pages
    const totalPages = Math.ceil(data.length / rowsPerPage);
  
    // Get the data for the current page
    const currentPageData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    return (
    <div>
      <h1>Ingestion Data Helper</h1>
      <p>To get/fetch, please pick StartDate and EndDate; DO NOT select StartDate more than last 30 days.</p>
      <div>
            <label><b>Start date</b></label>
            <input type= 'Date' className='startDate' onChange={handleStartDateChange} value = {startDate}/>
            <label><b>End date</b></label>
            <input type= 'Date' className='endDate' onChange={handleEndDateChange} value = {endDate}/>
        <Button variant="contained" color="primary" onClick={fetchData} style={{ marginLeft: '10px' }}>
          Fetch Data
        </Button>
        </div>
      {isLoading ? (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
          </div>
        ) : (
          <>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>CID</TableCell>
                  <TableCell>Short Title</TableCell>
                  <TableCell>CP Name</TableCell>
                  <TableCell>GenreName</TableCell>
                  <TableCell>Subgenre</TableCell>
                  <TableCell>SubSubgenre</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Resolution</TableCell>
                  <TableCell>V Bitrate</TableCell>
                  <TableCell>UploadTime</TableCell>
                  {/* Add more table headers based on your JSON response */}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentPageData.map((item) => (
                  <TableRow key={item.cid}>
                    <TableCell>{item.cid}</TableCell>
                    <TableCell>{item.shorttitle}</TableCell>
                    <TableCell>{item.cpname}</TableCell>
                    <TableCell>{item.genrename}</TableCell>
                    <TableCell>{item.subgenre}</TableCell>
                    <TableCell>{item.subsubgenre}</TableCell>
                    <TableCell>{item.duration}</TableCell>
                    <TableCell>{item.Resolution}</TableCell>
                    <TableCell>{item.v_bitrate}</TableCell>
                    <TableCell>{item.uploadtime}</TableCell>
                    {/* Add more table cells based on your JSON response */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination count={totalPages} page={currentPage} onChange={(event, value) => setCurrentPage(value)} />
            {data.length > 0 && (
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <CSVLink data={data} headers={csvHeaders} filename="DailyIngestionStat.csv">
                  <Button variant="contained" color="primary">
                    Export to CSV
                  </Button>
                </CSVLink>
              </div>
            )}
          </>
        )}
      </div>
    );
  };
  
export default IngestionStatsHelper;